// extracted by mini-css-extract-plugin
export default {"filterWrapper":"activityLog_filterWrapper__1TLeD","search":"activityLog_search__GdkzS","datatblWrapper":"activityLog_datatblWrapper__3iq5t"};